import { useState } from "react";
import {
  CheckIcon,
  CopyIcon,
  SaveIcon,
  TrashIcon,
  ViewIcon,
} from "../../../../../../assets";
import { copyToClipboard, openLinkInNewTab } from "../../../../../utils";
import {
  formatDate,
  getText,
  sanitizeHtml,
} from "../../../../../utils/_generic";
import {
  getHighlightedExcerpts,
  highlightFullText,
} from "../../../../../utils/_getHighlightedExcerpts";
import { PDLButton, PDLTypography } from "../../../dna";
import { ActionButton } from "../../../global";

const JurisprudenceItem = ({
  item,
  index,
  searchTerm,
  pushDown = false,
  cardProfileStyle = false,
  onRemove,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  const itemId = item.id || `jurisprudencia-${index}`;

  const fullHtmlContent = sanitizeHtml(
    item.texto ||
      item.resumo ||
      item.summary ||
      `Ementa não disponível para o item ${itemId}`
  );

  const textOnly = getText(fullHtmlContent);

  const excerpts = searchTerm
    ? getHighlightedExcerpts(textOnly, searchTerm, 180)
    : null;

  const displayContent = expanded
    ? getHighlightedExcerpts(textOnly, searchTerm, textOnly.length + 1)?.join(
        " "
      ) || textOnly
    : excerpts?.join(" ") || textOnly.slice(0, 500);

  const highlightedTitle = highlightFullText(item.titulo || "", searchTerm);

  const displayTitle = highlightedTitle ? highlightedTitle : item.titulo || "";

  const cleanTitle = sanitizeHtml(displayTitle);

  return (
    <div
      key={itemId}
      className={`pdl_components_lista_resultados_item mt-3 ${
        pushDown ? "push-down" : ""
      } ${cardProfileStyle ? "card-style" : ""}`}
    >
      <PDLTypography size="md" weight="semibold" variant="brand" upper>
        <span
          className="pdl-title-clamp-3"
          dangerouslySetInnerHTML={{ __html: cleanTitle }}
        />
      </PDLTypography>

      <div className="d-flex flex-row align-items-center justify-content-between my-2">
        <div>
          <PDLTypography as="span" size="sm">
            Jurisprudência
          </PDLTypography>
          &nbsp;&bull;&nbsp;
          <PDLTypography as="span" size="sm">
            {item.tribunal || "Tribunal"}
          </PDLTypography>
          &nbsp;&bull;&nbsp;
          <PDLTypography as="span" size="sm">
            {formatDate(item.data)}
          </PDLTypography>
          &nbsp;&bull;&nbsp;
          <PDLTypography as="span" size="sm">
            {item.relator || "Relator"}
          </PDLTypography>
        </div>

        <div className="btn-action-container flex gap-2">
          {item.link_integra && item.comintegra === "1" && (
            <ActionButton
              icon={<ViewIcon />}
              label="Ver acórdão"
              onClick={() => openLinkInNewTab(item.link_integra)}
            />
          )}
          <ActionButton icon={<SaveIcon />} label="Salvar" />
          <ActionButton
            icon={copied ? <CheckIcon /> : <CopyIcon />}
            label={copied ? "Copiado" : "Copiar"}
            onClick={() => {
              if (copied) return;
              setCopied(true);
              copyToClipboard(textOnly);
              setTimeout(() => setCopied(false), 2000);
            }}
          />
        </div>
      </div>

      <div className="text-container">
        <div
          className="content text-sm inline"
          dangerouslySetInnerHTML={{
            __html: `<strong>EMENTA:</strong> ${displayContent}`,
          }}
        />

        <PDLButton
          className="ps-2 mt-1 inline align-baseline"
          variant="link"
          style={{
            cursor: "pointer",
            display: "inline",
            paddingLeft: 4,
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Ver menos" : "Ver mais"}
        </PDLButton>
      </div>
      {pushDown && (
        <div className="btn-action-container-footer">
          <div className="btn-action-group-left">
            {item.link_integra && item.comintegra === "1" && (
              <ActionButton
                icon={<ViewIcon />}
                label="Ver acórdão"
                onClick={() => openLinkInNewTab(item.link_integra)}
              />
            )}
            <ActionButton
              icon={copied ? <CheckIcon /> : <CopyIcon />}
              label={copied ? "Copiado" : "Copiar"}
              onClick={() => {
                if (copied) return;
                setCopied(true);
                copyToClipboard(textOnly);
                setTimeout(() => setCopied(false), 2000);
              }}
            />
          </div>
          {onRemove && (
            <div className="btn-action-group-right">
              <button
                type="button"
                className="btn-remove-saved"
                onClick={() => onRemove(item)}
              >
                <TrashIcon color="#8c0000" />
                <span>Remover de salvos</span>
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default JurisprudenceItem;
